import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TrainersStudentModel } from 'common/models/page-models/Trainer Student/trainers-student-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TrainersStudentFormWidgetService } from 'common/widget/trainers-student/trainers-student-form-widget.services';

@Injectable({
    providedIn: 'root'
})
export class TrainersStudentFormResolver extends FormResolverService<TrainersStudentModel> {
    constructor(
        protected fs: TrainersStudentFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
